import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentFilters, ContentTopBar } from 'components';
import { MatrialFilterFormValues } from 'features/master/components/master-filter-form';
import { MatrialFilterForm } from 'features/master/components/master-filter-form/matrial-filter-form';
import { MatrialModalView } from 'features/master/components/modal/matrial-modal';
import { useState } from 'react';
import { SideBarMenus } from 'routes/constants';
import { CompanyType } from 'types';
import { HasPermission } from 'utils/CheckPermissions';
const { useBreakpoint } = Grid;

type MatrialTopBarProps = {
  getInitialFilterValues: MatrialFilterFormValues;
  handleFilter: (values: MatrialFilterFormValues) => void;
  userEditData: any;
  showAppUserModal:any;
  setShowAppUserModal:any
  onRefresh:() => void ;
   
};

export const MatrialTopBar = ({
  getInitialFilterValues,
  handleFilter,
  userEditData,
  showAppUserModal,
  setShowAppUserModal,
  onRefresh

}: MatrialTopBarProps) => {
  useState<CompanyType>();
  const formId = 'end-users-filters-form';
  const screens = useBreakpoint();

  const handleOpenModal = () => {
    setShowAppUserModal(true);
    document.body.style.overflow = 'hidden';
  }
  const handleCloseModal = () => {
    setShowAppUserModal(false);
    document.body.style.overflow = 'visible';
  }

  return (
    <>
      <div className={`cstmrightmdl ${showAppUserModal && "show"}`}>
        <MatrialModalView onClose={handleCloseModal} userEditData={userEditData} />
      </div>
      
      {HasPermission(SideBarMenus.MATERIAL, 'add') ? (
      <ContentTopBar title={'Material'}

        renderButtons={
          <div className='flex flex-nowrap"'>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              type='primary'
              onClick={handleOpenModal}
              style={{ marginRight: 10 }}
            >
              {'Add Material'}
            </Button>
          </div>
        }        
      />
       ):null}


      <ContentFilters formId={formId}>
        <MatrialFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
          onRefresh={onRefresh}
        />
      </ContentFilters>
    </>
  );
};
